import React, { useState, useEffect } from 'react'

export default function ImageGalleryModal({ images, initialIndex = 0, onClose }) {
    const [currentIndex, setCurrentIndex] = useState(initialIndex)

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                onClose()
            } else if (e.key === 'ArrowLeft') {
                goToPrevious()
            } else if (e.key === 'ArrowRight') {
                goToNext()
            }
        }

        document.addEventListener('keydown', handleKeyDown)
        return () => document.removeEventListener('keydown', handleKeyDown)
    }, [currentIndex, images.length])

    const goToNext = () => {
        setCurrentIndex((prev) => (prev + 1) % images.length)
    }

    const goToPrevious = () => {
        setCurrentIndex((prev) => (prev - 1 + images.length) % images.length)
    }

    if (!images || images.length === 0) return null

    const currentImage = images[currentIndex]

    return (
        <div
            className="modal is-active"
            onClick={onClose}
            style={{ zIndex: 9999 }}
        >
            <div className="modal-background" style={{ backgroundColor: 'rgba(0, 0, 0, 0.92)' }} />

            <div
                className="modal-content"
                onClick={(e) => e.stopPropagation()}
                style={{
                    width: '90%',
                    maxWidth: '1200px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                {/* Image */}
                <div style={{ position: 'relative', width: '100%', textAlign: 'center' }}>
                    <img
                        src={currentImage.image}
                        alt={currentImage.caption || `Расм ${currentIndex + 1}`}
                        style={{
                            maxWidth: '100%',
                            maxHeight: '80vh',
                            objectFit: 'contain',
                            borderRadius: '8px',
                            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.5)'
                        }}
                    />

                    {/* Previous Button */}
                    {images.length > 1 && (
                        <button
                            onClick={goToPrevious}
                            className="button is-large is-dark"
                            style={{
                                position: 'absolute',
                                left: '20px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                opacity: 0.8,
                                borderRadius: '50%',
                                width: '60px',
                                height: '60px',
                                padding: 0
                            }}
                            title="Олдинги (← yoki A)"
                        >
                            <ion-icon name="chevron-back-outline" style={{ fontSize: '32px' }} />
                        </button>
                    )}

                    {/* Next Button */}
                    {images.length > 1 && (
                        <button
                            onClick={goToNext}
                            className="button is-large is-dark"
                            style={{
                                position: 'absolute',
                                right: '20px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                opacity: 0.8,
                                borderRadius: '50%',
                                width: '60px',
                                height: '60px',
                                padding: 0
                            }}
                            title="Кейинги (→ yoki D)"
                        >
                            <ion-icon name="chevron-forward-outline" style={{ fontSize: '32px' }} />
                        </button>
                    )}
                </div>

                {/* Caption and Counter */}
                <div
                    style={{
                        marginTop: '20px',
                        color: 'white',
                        textAlign: 'center',
                        width: '100%'
                    }}
                >
                    {currentImage.caption && (
                        <p className="title is-5 has-text-white mb-2">{currentImage.caption}</p>
                    )}
                    <p className="subtitle is-6 has-text-grey-light">
                        {currentIndex + 1} / {images.length}
                    </p>
                </div>

                {/* Thumbnails */}
                {images.length > 1 && (
                    <div
                        style={{
                            display: 'flex',
                            gap: '10px',
                            marginTop: '20px',
                            flexWrap: 'wrap',
                            justifyContent: 'center',
                            maxWidth: '100%',
                            overflowX: 'auto',
                            padding: '10px'
                        }}
                    >
                        {images.map((img, idx) => (
                            <img
                                key={img.id}
                                src={img.image}
                                alt={img.caption || `Thumbnail ${idx + 1}`}
                                onClick={() => setCurrentIndex(idx)}
                                style={{
                                    width: '60px',
                                    height: '60px',
                                    objectFit: 'cover',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    border: idx === currentIndex ? '3px solid #3273dc' : '2px solid transparent',
                                    opacity: idx === currentIndex ? 1 : 0.6,
                                    transition: 'all 0.2s'
                                }}
                            />
                        ))}
                    </div>
                )}
            </div>

            {/* Close Button */}
            <button
                className="modal-close is-large"
                aria-label="close"
                onClick={onClose}
                title="Ёпиш (ESC)"
            />
        </div>
    )
}
